








































































































































































































































import axios from 'axios';
import EventBus from '@/eventBus';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';

export default {
    name: 'PaymentMethods',
    components: { CoHeadline, CoAlert, CoCard, CoFormGroup, CoSwitch, CoText, CoButton, CoLink, CoSkeleton, CoIcon },
    data() {
        return {
            form: {
                Card: false,
                SEPA: false,
                Ideal: false,
                CardForEventTicketing: false,
                SEPAForEventTicketing: false,
                IdealForEventTicketing: false,
            },
            loading: false,
        };
    },
    computed: {
        isFormValid() {
            return this.form.Card || this.form.SEPA || this.form.Ideal;
        },
    },
    mounted() {
        this.getPaymentMethods();
    },
    methods: {
        getPaymentMethods() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/admin/payment/stripe/payment-methods',
                withCredentials: true,
            })
                .then((response) => {
                    this.form = {
                        ...this.form,
                        ...(response?.data || {}),
                    };
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        setPaymentMethods() {
            if (!this.isFormValid) {
                EventBus.$emit('ERROR', {
                    Message: this.$t('errors.atLeastOneMethod'),
                });
                return;
            }
            this.loading = true;
            axios({
                method: 'PUT',
                url: '/admin/payment/stripe/payment-methods',
                withCredentials: true,
                data: this.form,
            })
                .then((response) => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('labels.changessaved'),
                    });
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
